export const SERVICES = [
  {
    title: 'Business Strategy',
    text: 'Guiding organizations through growth, restructuring and strategic expansion with data-driven insights and executive-level expertise.',
  },
  {
    title: 'Corporate Advisory',
    text: 'Providing tailored consulting in mergers, acquisitions, capital structuring and governance to strengthen enterprise value and operational efficiency.',
  },
  {
    title: 'Risk and Governance',
    text: 'Ensuring operational resilience and compliance through robust corporate governance frameworks and risk management systems.',
  },
  {
    title: 'Market Intelligence',
    text: 'Delivering deep analytical insights and competitive intelligence to support informed decision-making and strategic expansion.',
  },
  {
    title: 'Strategic Partnerships',
    text: 'Identifying and structuring long-term partnerships that foster innovation, sustainable growth and cross-sector collaboration.',
  },
];
